import { createSelector } from 'reselect';
import prop from 'ramda/es/prop';
import moment from 'moment-timezone';

type Props = { date: string, has_presales?: boolean, has_presales_time?: boolean }

const selectIsOrderAvailable: (state: any, props: Props) => boolean = createSelector(
  [
    prop('has_presales'),
    prop('has_presales_time'),
    (_, { date }) => date,
    () => moment().format('YYYY-MM-DD'),
  ],
  (hasPresales, hasPresalesTime, date, nowDate) => {
    if (!hasPresales) {
      return false;
    }
    return (hasPresalesTime
      ? moment(nowDate).isSameOrBefore(date, 'day')
      : moment(nowDate).isSame(date, 'day'));
  },
);

export default selectIsOrderAvailable;
